import { render, staticRenderFns } from "./DouYinProductImage.vue?vue&type=template&id=012af9ae&scoped=true"
import script from "./DouYinProductImage.vue?vue&type=script&lang=js"
export * from "./DouYinProductImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012af9ae",
  null
  
)

export default component.exports